import { render, staticRenderFns } from "./BaseContacts.vue?vue&type=template&id=00a27c38"
import script from "./BaseContacts.vue?vue&type=script&lang=js"
export * from "./BaseContacts.vue?vue&type=script&lang=js"
import style0 from "./BaseContacts.vue?vue&type=style&index=0&id=00a27c38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports